import React from 'react';
import { TbClockBolt } from "react-icons/tb";
import { MdOutlineQueryStats } from "react-icons/md";
import { LiaSchoolSolid } from "react-icons/lia";
import { BiBookReader } from "react-icons/bi";
import { LuBookOpenCheck } from "react-icons/lu";
import { TfiStatsDown } from "react-icons/tfi";
import Image from "../assets/imgSect3.svg"
const features = [
  { title: 'Acceso Rápido a la Información', description: 'La información que necesitas, cuando la necesitas.', icon: <TbClockBolt /> },
  { title: 'Centralización del Conocimiento', description: 'Todos tus recursos y conocimientos en un solo lugar, siempre actualizados.', icon: <LiaSchoolSolid /> },
  { title: 'Consistencia en la Información', description: 'Asegura que todos reciban datos precisos y uniformes.', icon: <LuBookOpenCheck /> },
  { title: 'Análisis de Datos ', description: 'Ajusta procesos en base a estadísticas en tiempo real.', icon: <MdOutlineQueryStats /> },
  { title: 'Reducción de Costos', description: ' Automatiza consultas, liberando a tu equipo para tareas estratégicas.', icon: <TfiStatsDown /> },
  { title: 'Autoformación', description: 'Permite a tus empleados aprender y resolver dudas de forma autónoma.', icon: <BiBookReader /> },
];

const Features = () => {
  return (
    <section className="text-center " id="features">
      <div className="divider-conteiner space-y-4  ">
        <h2 className="divider-titule mb:text-[6.5vw]">¿Qué ofrece MENTOR-IA?</h2>
        <h2 className="divider-body">Transforma Documentos en Conocimiento Útil</h2>
      </div>
      <div className='ft-section '>
        
   
      <div className='ft-list'>
        <div className="ft-grid ">
          {features.map((feature, index) => (
            <div key={index} className=" tags">
              <div className=" icon-pink animate-fade-in mb-4  " >{feature.icon}</div>
              <h3 className="ft-title">{feature.title}</h3>
              <p className="ft-p">{feature.description}</p>
            </div>
          ))}
        </div>

      </div>
      <div className="ft-image">
        <img src={Image} alt="Gráfico" className="max-w-full h-auto animate-zoom2" />
      </div>
     
      </div>
  
    </section>
  );
};

export default Features;
